import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const FeriasService = {
  async getFerias(filter) {

   return await BaseService.fetchResponseFromAPIPost(`ferias/pesquisar`,filter);

  },
  async obterFerias(filter=null) {

    const response = await BaseService.fetchResponseFromAPIPost(`ferias/pesquisar`, filter);
    if (response.error) {
      SnackBarModule(response.message, "error");
    }
    return response.message;
  },

  async getFeriasProrrogadas(page, perfil) {
    const response = await BaseService.fetchResponseFromAPIGet(`ferias/prorrogadas-interrompida?page=${page}&perfil=${perfil}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },
  
  async test() {
    return await BaseService.fetchResponseFromAPIGet(`inf`);
  },
  async getFeriasNaoSolicitada(filter) {
    const response = await BaseService.fetchResponseFromAPIPost(`ferias/nao-solicitadas`, filter);
    if (response.error) {
      SnackBarModule(response.message, "error");
    }
    return response.message;
  },
  async getFeriasParaVencer(filter) {
    const response = await BaseService.fetchResponseFromAPIPost(`ferias/para-vencer`, filter);
    if (response.error) {
      SnackBarModule(response.message, "error");
    }
    return response.message;
  },

  async getFeriasById(id) {
    const response = await BaseService.fetchResponseFromAPIGet(`ferias/${id}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async validarParametrizacao(){

    const response = await BaseService.fetchResponseFromAPIGet("ferias/validarParametrizacao");
    if (response.content != "Válido") {
      SnackBarModule(response.content, "error");
    }



  },

  async getExerciciosPesquisar(){
    const response = await BaseService.fetchResponseFromAPIGet("ferias/exercicioferias");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar as exercícios", "error");
    }
    return response.content;
  },

  async getExerciciosFeriasPremio(){
    const response = await BaseService.fetchResponseFromAPIGet("ferias/premio/exercicio");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os exercícios", "error");
    }
    return response.content;
  },

  async getGraduacao() {
    const response = await BaseService.fetchResponseFromAPIGet("graduacao");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar as graduações", "error");
    }
    return response.content;
  },

  async getUnidade(unidadeApoiadora = false) {

    const response = await BaseService.fetchResponseFromAPIGet(unidadeApoiadora ? "unidade?unidade_apoiadora=true" : "unidade");

    if (response.error) {
      SnackBarModule("Houve um erro ao listar as unidades", "error");
    }
    return response.content;
  },

  async getLotacao() {
    const response = await BaseService.fetchResponseFromAPIGet("lotacao");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar as unidades", "error");
    }
    return response.content;
  },

  async getLotacaoByUnidade(unidade) {
    const response = await BaseService.fetchResponseFromAPIGet(`lotacao-by-unidade/${unidade}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao listar as unidades por unidade", "error");
    }
    return response.content;
  },

  async getExercicio(postData) {
    const response = await BaseService.fetchResponseFromAPIPost("ferias/exercicio", postData);
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os exercícios", "error");
    }
    return response.message;
  },
  async getExerciciosEscolares(postData) {
    const response = await BaseService.fetchResponseFromAPIPost("ferias/exercicios-escolares", postData);
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os exercícios escolares", "error");
    }
    return response.message;
  },
  async getStatus() {
    const response = await BaseService.fetchResponseFromAPIGet("ferias/status");
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os status", "error");
    }
    return response.content;
  },
  async getValidacaoSolicitacao() {
    const response = await BaseService.fetchResponseFromAPIGet("ferias/validasolicitacao");
    if (response.error) {
      SnackBarModule("Houve um erro ao verificar permissão", "error");
    }

    return response.content;
  },

  async getMilitaresFeriasAgendada(postData) {
    const response = await BaseService.fetchResponseFromAPIPost("ferias/militares-agendado", postData);
    if (response.error) {
      SnackBarModule("Houve um erro ao verificar permissão", "error");
    }
    return response.message;
  },

  async getMilitaresResponsavel() {
    const response = await BaseService.fetchResponseFromAPIGet("listacomandantes");
    if (response.error) {
      SnackBarModule("Houve um erro ao verificar permissão", "error");
    }
    return response.content;
  },
  
  async getExercicioPorMilitar(idSigrh) {
    const response = await BaseService.fetchResponseFromAPIGet(`ferias/exercicio/${idSigrh}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os exercícios", "error");
    }
    return response.content;
  },

  async getExercicioEmFeriasCadaMilitar(idSigrh) {
    const response = await BaseService.fetchResponseFromAPIGet(`ferias/exercicioferias/${idSigrh}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os exercícios", "error");
    }
    return response.content;
  },
}